import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=4c7a1100&scoped=true&"
import script from "./ShopFooter.vue?vue&type=script&lang=js&"
export * from "./ShopFooter.vue?vue&type=script&lang=js&"
import style0 from "./ShopFooter.vue?vue&type=style&index=0&id=4c7a1100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a1100",
  null
  
)

export default component.exports